// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O-W4P","fullView":"styles_fullView__cjIvl"};